import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { IRootState } from 'store/serverInterfaces';
import Loading from 'components/Loading';
import { BonusCardType, IBonusCardProps } from 'components/BonusCard';
import { BonusIdentifier, BonusStatus } from 'constants/appEnums';
import BonusView, { IBonusViewProps } from './BonusView';

const Bonus = () => {
  // TODO: Use to correct type when available.
  const bonusCards: any[] | undefined = useSelector((state: IRootState) => state.DreamteamReducer.bonusCards);
  const cardData: IBonusCardProps[] | undefined = useMemo(
    () =>
      bonusCards?.map(
        (bonusCard) =>
          ({
            // TODO: Implement when the type becomes available.
          } as IBonusCardProps)
      ),
    [bonusCards]
  ) || [
    {
      type: BonusCardType.ReadyToUse,
      identifier: BonusIdentifier.NewSigning,
      expirationDate: Date.now() + 3 * 24 * 3600 * 1000,
      status: BonusStatus.active
    },
    {
      type: BonusCardType.ReadyToUse,
      identifier: BonusIdentifier.DecisionTime,
      expirationDate: Date.now() + 2 * 24 * 3600 * 1000,
      status: BonusStatus.unavailable
    },
    {
      type: BonusCardType.Locked,
      identifier: BonusIdentifier.NewSigning
    },
    {
      type: BonusCardType.Locked,
      identifier: BonusIdentifier.DecisionTime
    }
  ]; /* TODO: Remove the dummy cards when data becomes available. */

  if (!cardData) {
    return <Loading showText={true} />;
  }

  const data: IBonusViewProps = cardData.reduce<IBonusViewProps>(
    (accumulator, card) => {
      switch (card.type) {
        case BonusCardType.ReadyToUse:
          accumulator.readyCards.push(card);
          break;

        case BonusCardType.Locked:
          accumulator.lockedCards.push(card);
          break;
      }

      return accumulator;
    },
    {
      readyCards: [],
      lockedCards: []
    }
  );

  return <BonusView {...data} />;
};

export default Bonus;
